import { render, staticRenderFns } from "./RunnitTagFilterCarousel.vue?vue&type=template&id=e207aa66"
import script from "./RunnitTagFilterCarousel.vue?vue&type=script&lang=ts"
export * from "./RunnitTagFilterCarousel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports